"use client";
import React, { useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

function InfoBannerPart({
  i,
  invSpr = "290",
  title = "v investiční správě",
  unit = "Milionů Kč",
  className = "",
}) {
  const targetValue = parseFloat(invSpr);
  const container = useRef(null);
  const numRef = useRef(null);

  useGSAP(
    () => {
      let num = { val: 0 };
      const duration = targetValue * 0.01;
      gsap.to(num, {
        duration: duration,
        ease: "none",
        val: targetValue,
        scrollTrigger: {
          trigger: numRef.current,
          start: "top 75%",
          // end: "bottom 15%",
          toggleActions: "play none none none",
        },
        onUpdate: () => {
          numRef.current.textContent = Math.round(num.val);
        },
      });
    },
    { scope: container },
  ); // scope is important for proper cleanup

  let titleColor = "text-teal";
  if (i === 0) {
    titleColor = "text-teal";
    className += " md:pr-10";
  }
  if (i === 1) {
    titleColor = "text-gold";
    className += " md:px-10 md:py-0";
  }
  if (i === 2) {
    titleColor = "text-temRed";
    className += "pt-10 md:pl-10 md:pt-0 border-none";
  }

  return (
    <div
      ref={container}
      className={`infoBannerPart flex w-full min-w-[228px] max-w-full flex-1 shrink-0 flex-col items-center justify-start gap-4 ${className}`}
    >
      <div className="text-signature-teal flex flex-col items-center justify-start self-stretch">
        <h3
          className={`mq450:text-lg mq450:leading-[20px] mq925:text-5xl mq925:leading-[26px] relative self-stretch font-raleway text-3xl font-bold leading-[110%] tracking-[0.01em] md:leading-10 md:tracking-wide ${titleColor}`}
        >
          {title}
        </h3>
      </div>
      <p
        ref={numRef}
        className="mq450:text-17xl mq450:leading-[40px] mq925:text-29xl mq925:leading-[53px] relative self-stretch font-raleway text-6xl font-bold leading-[110%] tracking-[0.01em] text-slate-300 md:leading-10 md:tracking-wide"
      >
        0
      </p>
      <div className="flex flex-col items-center justify-start self-stretch">
        <div className="mq450:text-lgi mq450:leading-[21px] relative self-stretch font-raleway text-2xl text-slate-300 md:leading-relaxed md:tracking-tight">
          {unit}
        </div>
      </div>
    </div>
  );
}

export default InfoBannerPart;
